import axios from 'axios';

export const generatePowerCubeFile = async () => {
    const config = { responseType: 'blob' };
    const response = await axios.post('/power-cube-excel', {}, config);

    let filename = 'PowerCubeConnection.xlsx';
    if (response.headers['content-disposition'] !== undefined) {
        filename = response.headers['content-disposition'].match('(?<=filename=)(.*)(?=;)')[0];
    }

    return { file: response.data, name: filename };
};
